import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';

const Body = ({ children = <></>, className = '' }) => {
  return <div className={clsx('body', className)}>{children}</div>;
};

Body.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};

export default Body;
